import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { FNOLPARepairFacilityPage } from 'gwce-capability-fnol-pa-react-ext';
import React from 'react';

function FNOLRTRepairFacilityPage(props) {
    return <FNOLPARepairFacilityPage {...props} />;
}

FNOLRTRepairFacilityPage.propTypes = wizardProps;
export default FNOLRTRepairFacilityPage;
